import React from 'react';

const LazyComponent = React.lazy(() =>
    import(/* webpackChunkName: "SbRespFollowSearchBanner" */ './SbRespFollowSearchBanner')
);

export const SbRespFollowSearchBannerLazy = props => (
    <React.Suspense fallback="">
        <LazyComponent {...props} />
    </React.Suspense>
);
